import { ACTIVITY_FILTERS } from "constants/streaming";
import { EMPTY_FILTERS, CHECKBOX_GROUP_NAMES } from "./constants";
import * as Types from "./types";

const prepareActivityTypes: Types.PrepareActivitiesTypes = (data = []) =>
  data.map((activityType) => ({
    value: activityType.id,
    label: activityType.name,
  }));

export const getEntityIds: Types.GetEntityIds = (data = []) =>
  data.map(({ id }) => id);

export const getTypeName: Types.GetTypeName = (data = []) =>
  data.map(({ name }) => name);

export const getActivityIds: Types.GetEntityIds = (data = []) => [
  ...ACTIVITY_FILTERS.map((filter) => filter.value),
  ...getEntityIds(data),
];

export const getActivities: Types.GetActivities = (data = []) => [
  ...ACTIVITY_FILTERS,
  ...prepareActivityTypes(data),
];

export const getCategoryIds: Types.GetCategoryIds = (categoryTypes) =>
  categoryTypes.reduce<string[]>(
    (acc, topic) => [...acc, ...getEntityIds(topic.categories)],
    [],
  );

export const getResettedFilters: Types.GetResettedFilters = (
  entitiesCount,
  activityTypes,
) => ({
  search: "",
  types: getTypeName(entitiesCount.type),
  grades: getEntityIds(entitiesCount.grade),
  topics: getEntityIds(entitiesCount.topic),
  activities: getActivityIds(activityTypes),
  categories: [],
  activityTypes: [],
});

export const getIsDefault: Types.GetIsDefault = (data) =>
  !CHECKBOX_GROUP_NAMES.some(
    (filter) => Array.isArray(data[filter]) && data[filter].length,
  );

export const getInitialFilters: Types.GetInitialFilters = (
  { activities, topics, grades, types, categories, activityTypes, search = "" },
  entitiesCount,
  fetchedActivityTypes,
) => {
  if (!entitiesCount || !fetchedActivityTypes) {
    return EMPTY_FILTERS;
  }

  const isDefault = getIsDefault({ types, grades, topics, activities });

  return {
    ...EMPTY_FILTERS,
    search,
    categories,
    activityTypes,
    types: !(isDefault || types)
      ? EMPTY_FILTERS.types
      : types || getTypeName(entitiesCount.type),
    grades: !(isDefault || grades)
      ? EMPTY_FILTERS.grades
      : grades || getEntityIds(entitiesCount.grade),
    topics: !(isDefault || topics)
      ? EMPTY_FILTERS.topics
      : topics || getEntityIds(entitiesCount.topic),
    activities: !(isDefault || activities)
      ? EMPTY_FILTERS.activities
      : activities || getActivityIds(fetchedActivityTypes),
  };
};
